<template>
    <div>
        <md-toolbar class="md-transparent py-0 px-3" md-elevation="0">
            <div class="md-layout md-gutter">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                    </div>
                    <h4 class="title">Modification de la journée : <span class="font-medium">{{ $moment(day.date).format('DD/MM/YYYY') }}</span></h4>
                </div>
                <div class="md-layout-actions md-layout-item md-size-20 text-right align-center">
                    <div class="flex items-center justify-end header-actions">
                        <div>
                            <md-button class="md-icon-button md-raised md-warning" @click="$emit('close')">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'times']"></font-awesome-icon>
                            </md-button>
                            <md-tooltip md-direction="top">Fermer</md-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </md-toolbar>
        <form @submit.prevent="addAbsence">
            <div class="px-3 mt-1 pb-3">
                <p class="text-sm mb-2"><span class="font-medium">Technicien : </span> {{ technician.fullName }}</p>
                <md-divider class="mt-3 mb-2"></md-divider>
                <p class="text-sm mb-4"><span class="font-medium">Ajout d'une absence</span></p>
                <div class="md-layout mt-1">
                    <div class="md-layout-item md-size-100 pl-0">
                        <div class="md-multiselect md-multiselect-multiple">
                            <label>Type d'absence</label>
                            <multiselect v-model="absence" :options="absenceTypes"
                                         :clear-on-select="false" :preserve-search="true"
                                         :option-height="104" :show-labels="false"
                                         label="name" track-by="name"
                                         selectLabel="" placeholder="Type d'absence">
                                <template slot="noOptions">La liste est vide</template>
                                <template slot="noResult">Aucun élement correspondant</template>
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="md-layout mt-4">
                    <div class="md-layout-item md-size-25 pl-0">
                        <div class="md-vdatepicker">
                            <datetime v-model="start_date" type="time" auto
                                      :disabled="absence === null || absence.id !== 7"
                                      :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
                                      placeholder="HH:mm" :minute-step="5">
                                <label slot="before">Heure de début *</label>
                            </datetime>
                            <validation-error :errors="apiValidationErrors.start_date" />
                        </div>
                    </div>
                    <div class="md-layout-item md-size-25">
                        <div class="md-vdatepicker">
                            <datetime v-model="end_date" type="time" auto
                                      :disabled="absence === null || absence.id !== 7"
                                      :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
                                      placeholder="HH:mm" :minute-step="5">
                                <label slot="before">Heure de fin *</label>
                            </datetime>
                            <validation-error :errors="apiValidationErrors.end_date" />
                        </div>
                    </div>
                </div>
                <div class="md-layout mt-2">
                    <div class="md-layout-item md-size-100 pl-0">
                        <md-field class="md-invalid">
                            <label>Commentaire</label>
                            <md-input v-model="comment" type="text"></md-input>
                            <validation-error :errors="apiValidationErrors.comment" />
                        </md-field>
                    </div>
                </div>
                <md-divider class="mt-3 mb-4"></md-divider>
                <div class="panel-actions">
                    <md-button class="md-success" type="submit">Valider</md-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import dateTimeFormattingMixin from "@/mixins/date-time-formatting-mixin";

export default {
    name: "PanelAddAbsence",
    components: {
        ValidationError
    },
    mixins: [formMixin, dateTimeFormattingMixin],
    props: {
        day: Object,
        technician: Object
    },
    data() {
        return {
            absenceTypes: [],
            absence: null,
            start_date: null,
            end_date: null,
            comment: ''
        }
    },
    methods: {
        async getAbsenceTypes() {
            const { data } = await this.$store.dispatch('absences/getAbsenceTypes')
            this.absenceTypes = data
        },
        async addAbsence() {
            this.resetApiValidation()
            try {
                const { data } = await this.$store.dispatch('calendar/addAbsence', {
                    weekNumber: this.day.weekNumber,
                    day: this.day.date,
                    technician_id: this.technician.id,
                    absence_type_id: this.absence.id,
                    start_date: this.start_date ? this.$moment(this.start_date).format('HH:mm:ss') : null,
                    end_date: this.end_date ? this.$moment(this.end_date).format('HH:mm:ss') : null,
                    comment: this.comment
                })
                await this.$store.dispatch('alerts/success', 'Absence ajoutée')
                bus.$emit('updated-panel', data)
                this.$emit('close')
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        }
    },
    mounted() {
        this.getAbsenceTypes()
    }
}
</script>

<style scoped>

</style>
